import * as types from '../actions/actionTypes';

const initialState = {
    payload: {
        methods: [],
    },
    loading: false,
    error: null,
    success: null
}

const predictionMethods = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_PREDICTION_METHODS_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_PREDICTION_METHODS_SUCCESS:
            return { ...state, loading: false, success: true, payload: {  methods: action.payload } };     
        case types.GET_PREDICTION_METHODS_FAILURE :
            return { ...state, loading: false, success: false, error: action.error };
        default:
            return { ...state, loading: false, error: null, success: false };
    }
}

export default predictionMethods;